<template>
  <div class="online-studyEvaluate">
    <div class="train-Switch-box">
      <div class="train-Switch">
        <div class="switch-left">
          <div class="tabs">
            <span class="color-333">{{$t('Evaluation.ability')}}</span>
          </div>
        </div>
        <div class="switch-right">
          <em class="icon" @click="$router.back(-1)"></em>
        </div>
      </div>
    </div>
    <div class="ablity-analyse">
      <h3>{{studentInfo.examine_name}}</h3>
      <div class="echartAblity">
        <div id="myChart_funnel" style="width:500px;height:500px;"></div>
      </div>
    </div>
  </div>
</template>

<script>
import evaluationStore from "@/views/StudyCenter/Evaluation/Evaluation";
import echarts from "echarts";
export default {
  name: "ablityAnalyse",
  components: {},
  data() {
    return {
      studentInfo: {
        token: "",
        member_id: "",
        student_id: "", //学生ID
        examine_branch: "", //检测编号
        examine_name: "", //检测名称
        classcode_branch: "" //班别编号
      }
    };
  },
  mounted() {},
  updated() {},
  created() {
    this.studentInfo.token = this.$store.state.token;
    this.studentInfo.member_id = this.$store.state.member_id;
    this.studentInfo.student_id = this.$store.state.currentChild.student_id;
    this.studentInfo.examine_branch = this.$route.query.examine_branch;
    this.studentInfo.examine_name = unescape(this.$route.query.examine_name);
    this.getAbilityAnalysis();
  },
  watch: {},
  computed: {},
  methods: {
    myEchart(dataArr,dataWordArr) {
      let dom = document.getElementById("myChart_funnel");
      let myChart = echarts.init(dom);
      let app = {};
      let option = null;
      option = {
        tooltip: {
          trigger: "axis"
        },
        radar: [
          {
            indicator: dataWordArr,
            center: ["50%", "50%"],
            radius: 200,
            shape: 'circle',
            name: {
              textStyle: { color: "#FF5C67", fontSize: 18 }
            },
            axisLine: {
              lineStyle: {
                color: "rgba(131,141,158,.1)"
              }
            }
          }
        ],
        series: [
          {
            type: "radar",
            symbol: "circle", // 拐点的样式，还可以取值'rect','angle'等
            symbolSize: 8, // 拐点的大小
            tooltip: {
              trigger: "item"
            },
            itemStyle: { normal: { areaStyle: { type: "default" } } },
            data: [
              {
                value: dataArr,
                name: this.$t('Evaluation.ablityAnaly'),
                // 设置区域边框和区域的颜色
                itemStyle: {
                  normal: {
                    color: "rgba(255,92,103,1)",
                    lineStyle: {
                      color: "rgba(255,92,103,.3)"
                    }
                  }
                },
                //在拐点处显示数值
                label: {
                  normal: {
                    show: true,
                    formatter: params => {
                      // return params.value + "%";
                       return params.value;
                    }
                  }
                }
              }
            ]
          }
        ]
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    //错题练习 获取所有错题 - 接口
    getAbilityAnalysis() {
      this.$store.dispatch("setLoadingStatus", true);
      evaluationStore
        .getAbilityAnalysis({
          token: this.studentInfo.token, //登陆获取token
          member_id: this.studentInfo.member_id, //登陆获取的会员表
          student_id: this.studentInfo.student_id,
          examine_branch: this.studentInfo.examine_branch
        })
        .then(res => {
          if (res.data.error == 0) {
            let data = res.data.result.list.right_num;
            let dataWord = res.data.result.list.total;
            let dataArr = [];
            let dataWordArr = [];
            // data.forEach(function(item) {
            //   dataArr.push(parseInt(item.sum));
            // });
            // console.log(dataArr);
            // dataWord.forEach(function(item) {
            //   let obj = {
            //     text: item.ability_name,
            //     max: parseInt(item.sum)
            //   };
            //   dataWordArr.push(obj);
            // });

            data.forEach(function(v1) {
              dataWord.forEach(function(v2) {
                if (v1.ability_id == v2.ability_id) {
                  dataArr.push(Number((v1.sum / v2.sum * 100).toFixed(3)));
                }
              })
            });
            console.log(dataArr);
            dataWord.forEach(function(item) {
              let obj = {
                text: item.ability_name,
                max: 100
              };
              dataWordArr.push(obj);
            });
            console.log(dataWordArr);
            this.myEchart(dataArr,dataWordArr);
          }
           this.$store.dispatch("setLoadingStatus", false);
        });
    }
  }
};
</script>

<style lang="stylus">
.ablity-analyse {
  padding-top: 30px;
  text-align: center;

  h3 {
    font-size: 14px;
    columns: #333333;
    margin: 25px auto 30px;
  }

  .echartAblity {
    display: flex;
    justify-content: center;
  }
}
</style>
